import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import HeroSection from "../HeroSection";
import FooterSection from "../FooterSection";
import HowItWorksSection from "../HowItWorksSection";
import GymHopSection from "../GymHopSection";
import ContactUsSection from "../ContactUsSection";
import LogoSlider from "../LogoSlider";
import ThreeCardsSection from "../ThreeCardsSection";
import { useApi } from "../../../hooks";
import { getAllBusinessCall } from "../../../api/apiOperations";
import { Container } from "./styles";

const Home = () => {
  const { pathname } = useLocation();

  const { request: getAllBusinessCallReq } = useApi<any>({
    apiFunc: getAllBusinessCall,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    getAllBusinessCallReq();
  }, []);

  return (
    <Container>
      <HeroSection />
      <LogoSlider />
      <ThreeCardsSection />
      <HowItWorksSection />
      <ContactUsSection />
      <GymHopSection showSavings={true} buttonAction="signup" />
      <FooterSection />
    </Container>
  );
};

export default Home;
